import Vue from 'vue';
import Vuex, { MutationTree } from 'vuex';
/* store modules imports: */
import dataManagement, { DataManagementState } from '@/store/modules/dataManagement';

Vue.use(Vuex);

export interface RootState {
  rootState?: any;
  dataManagement: DataManagementState;
}

const state: RootState = {} as RootState;
const mutations: MutationTree<RootState> = {};

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    dataManagement
  },
});
